<template>
  <h4>
    <img src="@/assets/images/ico-360.svg" alt="360°ビュー" />
    館内を360°パノラマ写真でご覧いただけます
  </h4>
  <swiper
    :slides-per-view="4"
    :space-between="16"
    :centeredSlides="true"
    :loop="true"
    :breakpoints="breakpoints"
  >
    <swiper-slide
      v-for="(image, ind) in $halllist[galid].vrimg"
      :key="ind"
      @click="ModalOpen(require('../assets/images/' + galid + '/' + image[0]))"
    >
      <div class="imgwrap">
        <img
          :src="require('../assets/images/' + galid + '/small/' + image[0])"
          :alt="image[1]"
        />
        <p class="caption">
          {{ image[1] }}
        </p>
      </div>
    </swiper-slide>
  </swiper>
  <Modal v-if="modalstate" @my-click="modalstate = $event">
    <template v-slot:image>
      <a-scene embedded vr-mode-ui="enabled: false">
        <a-assets>
          <img id="my-texture" :src="modalimage" />
        </a-assets>
        <a-entity
          geometry="primitive: sphere; radius: 5; segmentsWidth: 36; segmentsHeight: 64"
          material="src: #my-texture; side: back"
          position="0 0 0"
        ></a-entity>

        <a-camera
          position="0 0 0"
          fov="90"
          look-controls-enabled="true"
          reverse-mouse-drag="false"
          wasd-controls-enabled="true"
        ></a-camera>
        <a-sky color="#333"></a-sky>
      </a-scene>
    </template>
  </Modal>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import Modal from "@/components/VrGalModal.vue";
import "swiper/css";
// Import Swiper styles
export default {
  data() {
    return {
      modalstate: false,
      modalimage: "",
    };
  },
  props: ["galid"],
  components: {
    Modal,
    Swiper,
    SwiperSlide,
  },
  methods: {
    ModalOpen(imgurl) {
      this.modalstate = true;
      this.modalimage = imgurl;
      return;
    },
  },
  setup() {
    return {
      breakpoints: {
        320: {
          slidesPerView: 1.8,
        },
        960: {
          slidesPerView: 2.5,
        },
        1280: {
          slidesPerView: 4,
        },
      },
    };
  },
};
</script>
<style lang="scss" scoped>
h4 {
  background-color: #ceecff;
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  padding: 1rem;
  margin-bottom: 1rem;
  @include tb {
    font-size: 1.25rem;
  }
  @include sp {
    font-size: 1rem;
  }
  img {
    width: 40px;
    height: 40px;
    margin-right: 1rem;
  }
}
.imgwrap {
  position: relative;
  aspect-ratio: 16/9;
  cursor: pointer;
  @include tb {
    aspect-ratio: 3/2;
  }
  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    z-index: 0;
  }
  .caption {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 1;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    background-color: rgba(0, 0, 0, 0.3);
  }
}
</style>
